const {h, render, Component} = require('preact');

class GrouponsLandingView extends Component {
  constructor(props) {
    super(props);
  };

  render() {
    return (
      <section className="main row cs_support_header" id="contact-us-body-content">
        <div className="twelve columns">
          <section className="module">
            <div className="module-body contact-us">
              <div className="row">
                {this.props.landingPage}
              </div>
            </div>
          </section>
        </div>
      </section>
    );
  }
}

module.exports = GrouponsLandingView
